import { IRegionResponseDto } from "@src/entities/requestHH/api/interfaces/regionsResponseDto";

export const moveImportantCitiesToTop = (cities: IRegionResponseDto[]) => {
  const priority = ["Москва", "Санкт-Петербург", "Московская область"];

  const priorityCities: IRegionResponseDto[] = [];
  const otherCities: IRegionResponseDto[] = [];

  for (const city of cities) {
    if (priority.includes(city.name)) {
      priorityCities.push(city);
    } else {
      otherCities.push(city);
    }
  }

  return [...priorityCities, ...otherCities];
};
